<template>
    <b-card class="inner-block review-templates">
        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex">
                    <b-input v-model="filter" id="search_review_template" type="text" :placeholder="$translate('search_review_template')"></b-input>
                    <slot></slot>
                </b-col>

            </b-row>
        </b-card-header>


        <b-card-body>
            <b-col class="page-block"><strong>{{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }} {{
                Math.ceil(rows
                    / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table :fields="fields" responsive :items="templates" :per-page="itemsPerPage" :current-page="currentPage"
                    :filter="filter">
                    <template #cell(id)="row">
                        <b-button :id="'view-item-type-btn-'+row.item.id" variant="pink-button" v-if="hasPermissionView" @click="$emit('show-item', row.item.id)"
                            class="mr-2 test-view-item-type-btn">
                            <img src="@/assets/images/icon/view.svg">
                        </b-button>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="float-right mt-4" v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage"
                        :next-text="$translate('next')" :prev-text="$translate('previous')" aria-controls="roleTable" pills
                        align="center"></b-pagination>
                </b-col>
            </b-row>



        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reviewTemplates-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() { },

    methods: {
        updateFilterState(value) {
        // Assuming you have a Vuex store set up
        this.$store.commit('checkoffTemplates/updateFilter', value);
        }
    },

    computed: {
        fields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'completed',
                    label: this.$translate('completed'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no'))
                },
                {
                    key: 'archived',
                    label: this.$translate('archived'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
            ]
        },
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },

        rows() {
            return this.templates.length
        }
    },
    watch: {
    filter(newVal) {
      this.updateFilterState(newVal);
    }
  },
}
</script>
<style></style>
